export const translations = {
  fr: {
    // Nav
    'nav.home': 'Accueil',
    'nav.specials': 'Spécialités',
    'nav.menu': 'Menu',
    'nav.about': 'Histoire',
    'nav.reserve': 'Réserver',
    // Hero
    'hero.eyebrow': 'Cuisine Sri Lankaise Authentique',
    'hero.h1.line1': 'Les saveurs de',
    'hero.h1.em1': "l'île",
    'hero.h1.em2': 'aux épices',
    'hero.desc': "Currys mijotés, kottu roti croustillants, sambols généreux — les recettes ancestrales du Sri Lanka, préparées avec passion chaque jour.",
    'hero.cta1': 'Voir le Menu',
    'hero.cta2': 'Réserver une table',
    'hero.badge.label': 'Ouvert tous les jours',
    'hero.badge.sub': 'Emporter disponible',
    // Features
    'feat1.title': 'Ingrédients Frais',
    'feat1.desc': 'Épices importées directement du Sri Lanka pour une authenticité totale.',
    'feat2.title': 'Recettes Ancestrales',
    'feat2.desc': 'Des plats transmis de génération en génération, cuisinés avec passion.',
    'feat3.title': 'À Emporter',
    'feat3.desc': 'Savourez nos plats chez vous. Sur réservation téléphonique.',
    // Specials
    'specials.label': 'Nos Coups de Cœur',
    'specials.title': 'Les Incontournables de Gemiya',
    'specials.sub': 'Plats choisis par notre chef.',
    'specials.viewall': 'Voir le Menu Complet →',
    'sc1.name': 'Kottu Roti Poulet',
    'sc1.desc': "Roti haché sauté avec poulet, légumes frais, œufs et épices sri lankaises. Le plat de rue par excellence.",
    'sc2.name': 'Egg Hoppers (Appa)',
    'sc2.desc': 'Crêpes de riz fermenté en forme de bol, œuf au centre, servies avec sambols maison.',
    'sc3.name': 'Black Pork Curry',
    'sc3.desc': "Un curry de porc riche et épicé, mijoté lentement avec poudre de curry rôtie et épices ancestrales.",
    'sc4.name': 'Riz & Curry Sri Lankais',
    'sc4.desc': 'Riz vapeur, currys de légumes et viande, papadum et sambols maison. Le festin complet.',
    // Photo strip
    'strip.hoppers': 'Egg Hoppers',
    'strip.curries': 'Currys Maison',
    // About
    'about.label': 'Notre Histoire',
    'about.title': 'Notre Histoire',
    'about.p1': "Chez Gemiya, chaque plat est une invitation au voyage. Nous préparons la cuisine sri lankaise avec les ingrédients traditionnels et les techniques ancestrales qui font la richesse de cette île extraordinaire.",
    'about.p2': "Des kottu roti croustillants aux currys parfumés, nos recettes respectent l'âme de la gastronomie sri lankaise — épices généreuses, sambols incontournables.",
    'chef.name': 'Chef Gemiya',
    'chef.role': 'Chef & Fondateur',
    'map.visit': 'Trouvez-nous',
    'map.address': 'France',
    'map.hours': 'Lun – Dim : 11h30 – 22h30\nHappy Hour : 16h – 19h',
    'map.btn': 'Réserver une Table',
    // Menu page
    'menu.label': 'La Carte Complète',
    'menu.title': 'Menu Gemiya',
    'menu.desc': 'Épices sri lankaises authentiques · Cuisine généreuse et pleine d\'âme',
    'tab.lunch': 'Buffet Midi',
    'tab.mains': 'Plats Principaux',
    'tab.street': 'Street Food',
    'tab.sides': 'Accompagnements',
    'tab.burgers': 'Sandwichs',
    'tab.buffet': 'Buffet & Salades',
    'tab.rice': 'Riz Frit',
    'tab.kottu': 'Kottu',
    'tab.devilled': 'Plats Devils',
    'tab.chapsuey': 'Chapsuey',
    'tab.pizza': 'Pizza & Burgers',
    'btn.order': 'Commander',
    'tag.special': '⭐ Spécial Déjeuner',
    'tag.bestseller': '★ Bestseller',
    // Menu categories
    'lunch.title': 'Buffet Sri Lankais & Sud Asiatique',
    'lunch.desc': 'Riz vapeur, currys de viande et de légumes du jour, sambols maison',
    'lunch.note': 'Déjeuner uniquement · À emporter disponible',
    'rice.title': 'Riz Sauté',
    'devil.title': 'Dewel / Deval',
    'devil.sub': 'Spicy Sri Lankan Stir Fry · épicé, savoureux, généreux',
    'kottu.sub': 'Le plat national sri lankais · roti haché, légumes, épices',
    'roti.title': 'Roti / Parôta & Rolls',
    'roti.sub': 'Appam, rolls et pains traditionnels · parfaits en entrée ou encas',
    'burgers.title': 'Sandwichs & Burgers',
    'burgers.sub': 'Servis avec frites',
    'burgers.fries': 'Servi avec frites',
    // Reservations
    'res.eyebrow': 'Réservation',
    'res.title': 'Réservez votre expérience',
    'res.desc': "Rejoignez-nous pour un voyage inoubliable à travers les saveurs authentiques du Sri Lanka.",
    'res.date.title': 'Date & Nombre de Convives',
    'res.guests': 'Convives',
    'res.occasion': 'Occasion',
    'res.times.title': 'Horaires Disponibles',
    'res.lunch': 'Déjeuner',
    'res.dinner': 'Dîner',
    'res.details.title': 'Vos Coordonnées',
    'form.fname': 'Prénom',
    'form.lname': 'Nom',
    'form.email': 'Adresse Email',
    'form.phone': 'Téléphone',
    'form.special': 'Demandes Spéciales (Optionnel)',
    'res.confirm': 'Confirmer la Réservation',
    'res.map.btn': 'Ouvrir sur Maps',
    'res.findus': 'Nous Trouver',
    'res.address.label': 'Adresse',
    'res.summary.title': 'Récapitulatif',
    'res.summary.desc': 'Complétez le formulaire pour sécuriser votre table.',
    'occ.dinner': 'Dîner',
    'occ.lunch': 'Déjeuner',
    'occ.birthday': 'Anniversaire',
    'occ.business': 'Affaires',
    'hours.label': 'Horaires',
    'hours.monFri': 'Lun – Ven',
    'hours.sat': 'Samedi',
    'hours.sun': 'Dimanche',
    'phone.label': 'Téléphone',
    // Footer
    'footer.desc': "Cuisine sri lankaise authentique préparée avec amour et épices au cœur de la France.",
    'footer.links': 'Liens Rapides',
    'footer.home': 'Accueil',
    'footer.contact': 'Contact',
    'footer.newsletter': 'Newsletter',
    'footer.newsletter.desc': 'Recevez nos offres et actualités.',
    'footer.catering': 'Traiteur',
    // Months & days for calendar
    'cal.months': 'Janvier,Février,Mars,Avril,Mai,Juin,Juillet,Août,Septembre,Octobre,Novembre,Décembre',
    'cal.days': 'Dim,Lun,Mar,Mer,Jeu,Ven,Sam',
    'cal.not_selected': 'Non sélectionné',
    'summary.guests_label': 'Convives',
    'confirm.msg': "✓ Demande de réservation envoyée ! Nous confirmerons par téléphone.",
    'confirm.heading': 'Réservation Envoyée !',
    'confirm.sub': 'Merci. Nous confirmerons votre table par téléphone ou e-mail sous 24 h.',
    'form.email.placeholder': 'vous@exemple.com',
    'form.phone.placeholder': '+33 6 12 34 56 78',
    'form.special.placeholder': 'Allergies, régimes particuliers...',
    'val.no_date': 'Veuillez sélectionner une date.',
    'val.send_error': "Une erreur s'est produite. Veuillez réessayer ou nous appeler directement.",
    'res.sending': 'Envoi en cours…',
    '404.msg': "La page que vous cherchez n'existe pas.",
    '404.btn': "Retour à l'accueil",
    // Links / QR landing page
    'links.eyebrow': 'Bienvenue chez',
    'links.desc': 'Retrouvez notre site, notre carte et réservez votre table.',
    'links.website': 'Site Web',
    'links.website.sub': 'Découvrir Gemiya',
    'links.menu': 'Notre Menu',
    'links.menu.sub': 'Voir la carte complète',
    'links.reservations': 'Réservations',
    'links.reservations.sub': 'Réserver une table',
    // Follow Us / QR social page
    'follow.eyebrow': 'Restons en contact',
    'follow.title': 'Suivez-nous',
    'follow.desc': "Rejoignez-nous sur les réseaux sociaux et partagez votre expérience chez Gemiya.",
    'follow.facebook': 'Facebook',
    'follow.facebook.sub': 'Aimez notre page',
    'follow.instagram': 'Instagram',
    'follow.instagram.sub': 'Suivez nos photos',
    'follow.tiktok': 'TikTok',
    'follow.tiktok.sub': 'Regardez nos vidéos',
    'follow.google': 'Avis Google',
    'follow.google.sub': 'Laissez-nous un avis',
    'follow.thanks': 'Merci de soutenir Gemiya ❤',
    'follow.back': "Retour à l'accueil",
  },
  en: {
    'nav.home': 'Home',
    'nav.specials': 'Specials',
    'nav.menu': 'Menu',
    'nav.about': 'Our Story',
    'nav.reserve': 'Book a Table',
    'hero.eyebrow': 'Authentic Sri Lankan Cuisine',
    'hero.h1.line1': 'Flavours of',
    'hero.h1.em1': 'the spice',
    'hero.h1.em2': 'island',
    'hero.desc': "Slow-cooked curries, crispy kottu roti, generous sambols — the ancestral recipes of Sri Lanka, prepared with passion every day.",
    'hero.cta1': 'View Menu',
    'hero.cta2': 'Book a Table',
    'hero.badge.label': 'Open every day',
    'hero.badge.sub': 'Takeaway available',
    'feat1.title': 'Fresh Ingredients',
    'feat1.desc': 'Spices imported directly from Sri Lanka for total authenticity.',
    'feat2.title': 'Ancestral Recipes',
    'feat2.desc': 'Dishes passed down through generations, cooked with passion.',
    'feat3.title': 'Takeaway',
    'feat3.desc': 'Enjoy our dishes at home. Order by phone.',
    'specials.label': 'Our Favourites',
    'specials.title': 'Gemiya Must-Tries',
    'specials.sub': 'Hand-picked by our chef.',
    'specials.viewall': 'View Full Menu →',
    'sc1.name': 'Chicken Kottu Roti',
    'sc1.desc': "Chopped flatbread stir-fried with chicken, fresh vegetables, eggs and Sri Lankan spices. The ultimate street food.",
    'sc2.name': 'Egg Hoppers (Appa)',
    'sc2.desc': 'Bowl-shaped fermented rice pancakes with a soft egg centre, served with homemade sambols.',
    'sc3.name': 'Black Pork Curry',
    'sc3.desc': "A rich, dark, spicy pork curry slow-cooked with roasted curry powder and ancestral spices.",
    'sc4.name': 'Rice & Curry Feast',
    'sc4.desc': 'Steamed rice, vegetable curries, papadum and homemade sambols. The complete island feast.',
    'strip.hoppers': 'Egg Hoppers',
    'strip.curries': 'House Curries',
    'about.label': 'Our Story',
    'about.title': 'Our Story',
    'about.p1': "At Gemiya, every dish is an invitation to travel. We prepare Sri Lankan cuisine with traditional ingredients and ancestral techniques that make this extraordinary island so rich.",
    'about.p2': "From crispy kottu roti to fragrant curries, our recipes honour the soul of Sri Lankan gastronomy — generous spices and essential sambols.",
    'chef.name': 'Chef Gemiya',
    'chef.role': 'Head Chef & Founder',
    'map.visit': 'Find Us',
    'map.address': 'France',
    'map.hours': 'Mon – Sun: 11:30 AM – 10:30 PM\nHappy Hour: 4:00 PM – 7:00 PM',
    'map.btn': 'Book a Table',
    'menu.label': 'Full Menu',
    'menu.title': 'Gemiya Menu',
    'menu.desc': "Authentic Sri Lankan spices · Generous cuisine full of soul",
    'tab.lunch': 'Lunch Buffet',
    'tab.mains': 'Mains',
    'tab.street': 'Street Food',
    'tab.sides': 'Sides & Sambols',
    'tab.burgers': 'Sandwiches',
    'tab.buffet': 'Buffet & Salads',
    'tab.rice': 'Fried Rice',
    'tab.kottu': 'Kottu',
    'tab.devilled': 'Devilled',
    'tab.chapsuey': 'Chapsuey',
    'tab.pizza': 'Pizza & Burgers',
    'btn.order': 'Order Now',
    'tag.special': '⭐ Lunch Special',
    'tag.bestseller': '★ Bestseller',
    'lunch.title': 'Sri Lankan & South Asian Buffet',
    'lunch.desc': 'Steamed rice, daily meat & vegetable curries, homemade sambols',
    'lunch.note': 'Lunch only · Takeaway available',
    'rice.title': 'Fried Rice',
    'devil.title': 'Dewel / Deval',
    'devil.sub': 'Spicy Sri Lankan Stir Fry · hot, flavourful, generous',
    'kottu.sub': "Sri Lanka's national dish · chopped roti, vegetables, spices",
    'roti.title': 'Roti / Parôta & Rolls',
    'roti.sub': 'Appam, rolls and traditional breads · perfect as starter or snack',
    'burgers.title': 'Sandwiches & Burgers',
    'burgers.sub': 'Served with fries',
    'burgers.fries': 'Served with fries',
    'res.eyebrow': 'Reservations',
    'res.title': 'Reserve Your Experience',
    'res.desc': "Join us for an unforgettable journey through the authentic flavours of Sri Lanka.",
    'res.date.title': 'Select Date & Guests',
    'res.guests': 'Guests',
    'res.occasion': 'Occasion',
    'res.times.title': 'Available Times',
    'res.lunch': 'Lunch',
    'res.dinner': 'Dinner',
    'res.details.title': 'Your Details',
    'form.fname': 'First Name',
    'form.lname': 'Last Name',
    'form.email': 'Email Address',
    'form.phone': 'Phone Number',
    'form.special': 'Special Requests (Optional)',
    'res.confirm': 'Confirm Reservation',
    'res.map.btn': 'Open in Maps',
    'res.findus': 'Find Us',
    'res.address.label': 'Address',
    'res.summary.title': 'Reservation Summary',
    'res.summary.desc': 'Complete the form to secure your table.',
    'occ.dinner': 'Dinner',
    'occ.lunch': 'Lunch',
    'occ.birthday': 'Birthday',
    'occ.business': 'Business',
    'hours.label': 'Opening Hours',
    'hours.monFri': 'Mon – Fri',
    'hours.sat': 'Saturday',
    'hours.sun': 'Sunday',
    'phone.label': 'Phone',
    'footer.desc': "Authentic Sri Lankan cuisine served with love and spice in the heart of France.",
    'footer.links': 'Quick Links',
    'footer.home': 'Home',
    'footer.contact': 'Contact',
    'footer.newsletter': 'Newsletter',
    'footer.newsletter.desc': 'Subscribe for offers and updates.',
    'footer.catering': 'Catering',
    'cal.months': 'January,February,March,April,May,June,July,August,September,October,November,December',
    'cal.days': 'Sun,Mon,Tue,Wed,Thu,Fri,Sat',
    'cal.not_selected': 'Not selected',
    'summary.guests_label': 'Guests',
    'confirm.msg': '✓ Reservation request sent! We will confirm by phone shortly.',
    'confirm.heading': 'Reservation Sent!',
    'confirm.sub': 'Thank you. We will confirm your table by phone or email within 24 hours.',
    'form.email.placeholder': 'you@example.com',
    'form.phone.placeholder': '+33 6 12 34 56 78',
    'form.special.placeholder': 'Allergies, dietary requirements...',
    'val.no_date': 'Please select a date.',
    'val.send_error': 'Something went wrong. Please try again or call us directly.',
    'res.sending': 'Sending…',
    '404.msg': "The page you're looking for doesn't exist.",
    '404.btn': 'Back to Home',
    // Links / QR landing page
    'links.eyebrow': 'Welcome to',
    'links.desc': 'Find our website, browse the menu, or book your table.',
    'links.website': 'Website',
    'links.website.sub': 'Discover Gemiya',
    'links.menu': 'Our Menu',
    'links.menu.sub': 'View the full menu',
    'links.reservations': 'Reservations',
    'links.reservations.sub': 'Book a table',
    // Follow Us / QR social page
    'follow.eyebrow': 'Stay in touch',
    'follow.title': 'Follow Us',
    'follow.desc': 'Join us on social media and share your Gemiya experience with others.',
    'follow.facebook': 'Facebook',
    'follow.facebook.sub': 'Like our page',
    'follow.instagram': 'Instagram',
    'follow.instagram.sub': 'Follow our photos',
    'follow.tiktok': 'TikTok',
    'follow.tiktok.sub': 'Watch our videos',
    'follow.google': 'Google Review',
    'follow.google.sub': 'Leave us a review',
    'follow.thanks': 'Thank you for supporting Gemiya ❤',
    'follow.back': 'Back to Home',
  }
};
